import axios from 'axios';
// import { env } from 'config/env.js';
// import getRequest from 'utils/getRequest.js';
import { requestInter, responseInter } from './requestInter';
// let type = process.env.VUE_APP_ENV;
// let baseUrl = env[type]['ajaxPath'];
let token = localStorage.getItem('token') || '';
let headers  = {}
if(token){
    headers.Authorization = 'bearer' +token ; 
}
// delete axios.defaults.headers.common["Cookie"];
let fetch = axios.create({
    // timeout: 10000,
    baseURL: 'http://ai.tcmcds.com',
    headers: headers, 
    withCredentials:true,

});

requestInter(fetch);
responseInter(fetch);
export default fetch;